import { PurchaseContainer } from "@features/dashboard";
import type { ProductType } from "@memorang/types";
import { useLocalSearchParams, useRouter } from "expo-router";

const PurchaseRoute = () => {
	const router = useRouter();
	const { productType } = useLocalSearchParams<{
		productType?: ProductType;
	}>();

	return (
		<PurchaseContainer
			productType={productType}
			handleClose={() => router.back()}
		/>
	);
};

export default PurchaseRoute;
